import { PureComponent } from 'react';
import i10n from '../../common/i10n';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import clear from '../../common/components/clear';
import sitemap from '../../common/sitemap';
import { UserHelper } from '../../common/helpers/userHelper';
import { CommonLayout } from '../../common/components/layouts/layout';
import { GetUrl } from '../../common/services/utilities';
import { getFormattedFileSize } from '../../common/helpers/toolsHelper';
import { AsyncSVG } from '../../common/components/AsyncSVG';
import { getLocalizedLink } from '../../common/components/tool';
import { Metadata } from '../../common/metadata';
import { formatCurrency } from '../../common/helpers/detectLocale';
import config from '../../config';
import { setUrlRedirectOnLogin } from '../../common/reducers/toolLayoutReducer';
import moment from "moment/moment";



const pageId = "3839C636-078D-4654-A5B2-C83E7A6A5AD8";

class Plans extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            redirectToSignUp: null
        }
    }

    componentDidMount() {
        UserHelper.GetPlansPrices().then(plansPrices => {
            this.setState({
                currency: plansPrices[0].currencyCode,
                prices: plansPrices,
                loadPriceFinish: true
            });
        }, () => {
            //If we failed to load price from payment provider, we use the plan price as fallback
            this.setState({
                loadPriceFinish: true
            });
        });
    }

    buyPlan = (planId) => {
        const planUrl = `${GetUrl([sitemap.ACCOUNT_CONTROLLER_ROUTE, sitemap.ACCOUNT_BUY_PLAN])}?planId=${planId}`;
        if (UserHelper.IsLoggedIn()) {
            window.location = planUrl;
        } else {
            this.props.setUrlRedirectOnLogin(planUrl);
            this.setState({ redirectToSignUp: planUrl });
        }
    }

    getPlanBillRecurrentLabel(plan) {
        switch (plan.PriceDebitInterval) {
            case 0:
                return i10n._VIEW_PRICING_RECURRENT_BILLING_DAY;
            case 1:
                return i10n._VIEW_PRICING_RECURRENT_BILLING_WEEK;
            case 2:
                return i10n._VIEW_PRICING_RECURRENT_BILLING_MONTH;
            case 3:
                return i10n._VIEW_PRICING_RECURRENT_BILLING_YEAR;
        }
    }

    getFormattedPrice = plan => {
        if (plan.Price === 0 || !plan.priceWithVat) {
            return formatCurrency(plan.Price, 0, this.state.currency);
        } else if (!plan.priceWithVat) {
            return " ";
        } else {
            return formatCurrency(plan.priceWithVat, 0, plan.currency);
        }
    }
    
    getGetPlanResetInterval() {
        const freePlan = window.AvePDFAppState.Plans[0];
        return moment.duration(freePlan.ResetPeriod).asHours();
    }

    render() {
        if (this.state.redirectToSignUp !== null) {
            return <Redirect to={getLocalizedLink(sitemap.VIEW_ACCOUNT_REGISTER_ROUTE)} />
        }
        const plans = window.AvePDFAppState && window.AvePDFAppState.Plans && window.AvePDFAppState.Plans.filter(plan => plan.Hidden == false).map(plan => {
            if (this.state.prices) {
                const planPrice = this.state.prices.find(price => price.planId === plan.Id);
                if (planPrice) {
                    return {
                        ...plan,
                        priceWithVat: planPrice.price,
                        currency: planPrice.currencyCode
                    };
                }
            }
            return plan;
        });

        return (<CommonLayout pageId={pageId}>
            <Metadata />
            <div className="mt-3">
                <div className="row justify-content-center py-3">

                    <div className="col-12 text-center">
                        <h1 className="home-header mb-5">{i10n._VIEW_PRICING_TITLE}</h1>
                    </div>

                    {
                        plans.map(plan =>
                            <div className="col-xl-5 col-lg-6 mb-3">
                                <div className={`card border-0 h-100 plan-card ${plan.Id !== null ? "premium-card" : ''}`}>
                                    <div className="card-header">
                                        <h2 className="card-title bold plan-name">AvePDF {plan.Name} 
                                            <span className="plan-users">
                                                <AsyncSVG className="plan-users-icon" src="/images/user-icon.svg" />
                                                <span className="d-inline-block">1</span>
                                            </span>
                                        </h2>
                                        {
                                            this.state.loadPriceFinish &&
                                            <p className="plan-pricing"><span className="plan-value">{this.getFormattedPrice(plan)}</span>{plan.PriceDebitInterval !== 0 ? ' / ' : ''}<span className='plan-period'>{plan.PriceDebitInterval === 3 ? i10n._VIEW_PRICING_TIME_INTERVAL_YEAR : ""}</span></p>
                                            ||
                                            <div className="placeholder-wrapper price-placeholder">
                                                <div className="placeholder-content">
                                                    <div className="placeholder-content-item">
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            plan.Id !== null &&
                                            <>
                                                {
                                                    this.state.loadPriceFinish &&
                                                    <div>
                                                        <p className="small mb-0">{this.getPlanBillRecurrentLabel(plan)}</p>
                                                        <p className="small">{i10n._VIEW_PRICING_DEBIT_INTERVAL_LABEL} <strong>{this.getFormattedPrice(plan)}</strong>.</p>
                                                    </div>
                                                    ||
                                                    <div>
                                                        <p className="small mb-0">{this.getPlanBillRecurrentLabel(plan)}</p>
                                                        <p className="small">{i10n._VIEW_PRICING_DEBIT_INTERVAL_LABEL}.</p>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                    <div className="card-body pt-0">

                                        <div className="plan-btn-wrapper mb-3">
                                            {
                                                plan.Id !== null &&
                                                <>
                                                    {/* {
                                                        UserHelper.IsUsingPaidPlan() &&
                                                        <div className="d-inline-block">
                                                            <button disabled className="ant-btn ant-btn-default ant-btn-buy my-2">{i10n._VIEW_PRICING_SELECT_BUTTON_LABEL}</button>
                                                        </div>
                                                        ||
                                                    } */}
                                                        <button className="ant-btn ant-btn-default ant-btn-buy my-2" onClick={() => this.buyPlan(plan.Id)}>{i10n._VIEW_PRICING_SELECT_BUTTON_LABEL}</button>
                                                </>
                                                ||
                                                <Link to={getLocalizedLink(sitemap.VIEW_HOME_INDEX_ROUTE)}><button className="ant-btn ant-btn-default ant-btn-buy my-2">{i10n._VIEW_PRICING_GET_STARTED_BUTTON_LABEL}</button></Link>
                                            }
                                        </div>
                                        {/* <p className="medium">{i10n._VIEW_PRICING_PLAN_INCLUDES.replace('#xxx', plan.Name)}</p> */}
                                        <ul className="plan-features">
                                            <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_TOOLS}</li>
                                            {
                                                plan.MaxDailyActions > 0 &&
                                                <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_OPERATION.replace("#xxx", this.getGetPlanResetInterval())} <span className="sbold">{plan.MaxDailyActions === 0 ? "Unlimited" : plan.MaxDailyActions}</span></li>
                                                ||
                                                <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_NO_MAX_OPERATION}</li>
                                            }
                                            <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_FILE_SIZE} <span className="sbold">{getFormattedFileSize(plan.MaxUploadFileSize, 0)}</span></li>
                                            <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_FILE_BATCH} <span className="sbold">{plan.MaxBatchUploadCount}</span></li>
                                            {
                                                plan.Price > 0 &&
                                                <>
                                                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_BETA_FEATURE}</li>
                                                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_NO_ADS}</li>
                                                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_SUPPORT}</li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                    <div>
                                        {
                                            plan.Id !== null &&
                                            <div className="card-footer px-4">
                                                    <ul className="list-inline">
                                                        <li className="list-inline-item"><AsyncSVG className="plan-icon-footer" src="/images/cancel-anytime.svg" />{i10n._VIEW_PRICING_PLAN_GIVEBACK_1}</li>
                                                        <li className="list-inline-item"><AsyncSVG className="plan-icon-footer" src="/images/30-days-back.svg" />{i10n._VIEW_PRICING_PLAN_GIVEBACK_2}</li>
                                                </ul>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                        ) || <p>NO PLANS</p>}

                    <div className="col-8 text-center mt-5">
                        <h3>{i10n._VIEW_PRICING_PLAN_SECURITY_TITLE}</h3>
                        <p>{i10n._VIEW_PRICING_PLAN_SECURITY_SUBTITLE}</p>
                    </div>
                    <div className="col-8 text-center mt-3">
                        <AsyncSVG className="secure-data-icon" src="/images/secure-payment.svg" />
                        <AsyncSVG className="secure-data-icon" src="/images/ssl.svg" />
                        <AsyncSVG className="secure-data-icon" src="/images/gdpr.svg" />
                    </div>

                </div>
            </div>

        </CommonLayout>)
    }
}

const mapState = ({ tool }) => {
    return {
        lang: tool.lang
    };
}
const mapDispatch = (dispatch) => {
    return {
        setUrlRedirectOnLogin(url) {
            dispatch(setUrlRedirectOnLogin(url));
        }
    };
}
const PlansContainer = clear(connect(mapState, mapDispatch)(Plans));
export default PlansContainer;
